import firebase from '@firebase/app'
import 'firebase/firestore'
import 'firebase/firebase-auth'
import 'firebase/storage'
// Initialize Firebase
var config = {

  apiKey: "AIzaSyB8mX_mg9LjoRkELWnf0Tmvi-8S2zjTuAQ",
  authDomain: "homedinamics.firebaseapp.com",
  databaseURL: "https://homedinamics.firebaseio.com",
  projectId: "homedinamics",
  storageBucket: "homedinamics.appspot.com",
  messagingSenderId: "1095371663361",
  appId: "1:1095371663361:web:750f193cf7170bf6"

};

const fb = firebase.initializeApp(config);

const db = firebase.firestore();

export {
  fb,
  db
}